export default __webpack_public_path__ + "static/media/robot.db96c329.png";